export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-torso-female-ed07d1fe1fc3b976c1e073db21b362c3.svg";